var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"d-flex justify-center align-center",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]),_c('v-layout',[_c('v-img',{attrs:{"src":_vm.signature,"max-width":"300px","max-height":"300px"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }